// @ts-nocheck
import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { GetMyRequest } from '../../../../store/Ame/ameRequestSlice.js';
// import Pagination from '../../../../components/Shared/Pagination/Pagination.jsx';
import Loading from '../../../../components/Shared/Loader/Loading';
import NeatixModal from '../../../../components/Modal/NeatixModal.jsx';
import OnlyViewRequests from '../../../Ame/ViewRequests/OnlyViewRequests.jsx';
import AmeForm from './AmeForm/AmeForm.jsx';
import { Link } from 'react-router-dom';
import { CardBody } from '../../../../components/card/card.jsx';
import NtxTable from '../../../../components/DataTable/NtxTable.jsx';
import { useAppSelector } from '@store/hooks';
import { getPersonId } from  '@store/Login2/authSelectors';

const MyRequests = () => {
  const personId = useAppSelector(getPersonId); // Get the person ID from the Redux store
  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [transactionHistoryId, setTransactionHistoryId] = useState('');

  const { t, i18n } = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage] = useState(7);
  const dispatch = useDispatch();
  const { MyRequestList, loadingGetMyRequest, errorGetMyRequest } = useSelector(state => state.AmeRequest);
  const [search, setSearch] = useState('');

  const filteredSearch = MyRequestList?.slice()?.filter(item => {
    const searchLowerCase = search.toLowerCase();
    return (
      item.requestName?.toLowerCase().includes(searchLowerCase) ||
      item.requestName2?.toLowerCase().toString().includes(searchLowerCase)
    );
  });

  useEffect(() => {
    dispatch(GetMyRequest());
  }, [dispatch]);

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = filteredSearch?.slice(indexOfFirstData, indexOfLastData);

  const columns = [
    { title: t('NumberOfRequest'), key: 'No' },
    { title: t('TypeOfRequest'), key: 'type' },
    { title: t('DateOfRequest'), key: 'date' },
    { title: t('Status'), key: 'status' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData =
    MyRequestList &&
    MyRequestList?.slice()
      ?.sort((a, b) => b.no - a.no)
      ?.map((item, index) => {
        let rowClass;

        return {
          // No: ++index,
          No: `#${item.no}`,
          type: i18n.language === 'ar' ? item.requestName2 : item.requestName,
          date: item.dateCreated,
          status:
            item.status === 'APPROVED' ? (
              <span className='badge border border-success text-success px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
                <i className='fa fa-check-circle fs-18px fa-fw me-5px'></i>
                {t('APPROVED')}
              </span>
            ) : item.status === 'IN PROGRESS' ? (
              <span className='badge border border-primary text-primary px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
                <i className='fa fa-spinner fs-18px fa-fw me-5px'></i>
                {t('INPROGRESS')}
              </span>
            ) : item.status === 'REJECTED' ? (
              <span className='badge border border-danger  text-danger  px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
                <i className='fa fa-times-circle fs-18px fa-fw me-5px '></i>
                {t('REJECTED')}
              </span>
            ) : (
              ''
            ),
          action: (
            <>
              {' '}
              <Link
                to=''
                onClick={() => {
                  setTransactionHistoryId(item.transectionHistoryId);
                  setShowModal1(true);
                }}
              >
                <i
                  className='fas fa-lg fa-fw fa-info-circle cursor-pointer'
                  style={{ color: 'var(--theme-color)' }}
                ></i>
              </Link>
            </>
          ),

          rowClass // استخدم rowClass هنا
        };
      });

  const renderAccessRestrictedMessage = () => (
    <div className='text-center p-4'>
      <div className='shadow alert alert-warning d-flex align-items-center justify-content-center' role='alert'>
        <i className='bi bi-exclamation-triangle-fill me-2 fs-4'></i>
        <div>
          <p className='mb-0'>
            {i18n.language === 'en'
              ? 'You need to be logged in as an employee to access this feature. Please check your account or contact support.'
              : 'يجب أن تكون مسجلاً كموظف للوصول إلى هذه الميزة. يرجى التحقق من حسابك أو التواصل مع الدعم.'}
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className='row'>
        <div className='col-lg-6'>
          <div className='input-group flex-nowrap input-group-sm'>
            <span className='input-group-text fw-bold'>{t('Search')}</span>
            <div className='input-group'>
              <div className='flex-fill position-relative'>
                <div className='input-group border-0 '>
                  <div className='input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0'>
                    <i className='fa fa-search opacity-5 text-theme'></i>
                  </div>
                  <input
                    type='text'
                    autoComplete='off'
                    className='form-control  form-control-sm  ps-35px'
                    value={search}
                    onChange={e => {
                      setSearch(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-lg-6 text-end'>
          <button className='btn me-1 btn-sm btn-outline-theme' onClick={() => setShowModal2(true)}>
            <i className='fas fa-lg fa-fw fa-plus-circle me-2'></i>
            {t('NewRequest')}
          </button>
        </div>
      </div>

      {!personId ? (
        renderAccessRestrictedMessage()
      ) : (
        <Loading loading={loadingGetMyRequest} error={errorGetMyRequest} Type='Dots'>
          <div className='pt-2'>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={5}
              theadClass=''
              tableClass='table text-nowrap table-hover '
            />
          </div>
        </Loading>
      )}

      <NeatixModal show={showModal1} setShow={setShowModal1} size='xl' bodyClassName='p-0' showHeader={true}>
        {transactionHistoryId && <OnlyViewRequests TransactionHistoryId={transactionHistoryId} />}
      </NeatixModal>

      <NeatixModal
        show={showModal2}
        setShow={setShowModal2}
        size='xl'
        title={t('SelfServiceRequests')}
        bodyClassName='p-0'
        showHeader={true}
      >
        <CardBody className='p-3'>
          <AmeForm />
        </CardBody>
      </NeatixModal>
    </>
  );
};

export default MyRequests;

// <div className="table-responsive  rounded-2">
// <table className="table  text-nowrap table-hover">
//   <thead className="bg-theme bg-opacity-25  p-1 mb-1">
//     <tr>
//       <th>{t('NumberOfRequest')}</th>
//       <th>{t('TypeOfRequest')}</th>
//       <th>{t('DateOfRequest')}</th>
//       <th>{t('Status')}</th>
//       <th>{t('')}</th>
//     </tr>
//   </thead>
//   <tbody>
//     {currentData?.map((item, index) => (
//       <tr key={item.transectionHistoryId}>
//         <td className="align-middle">{++index}</td>
//         <td className="align-middle">
//           {i18n.language === 'ar' ? item.requestName2 : item.requestName}{' '}
//         </td>

//         <td className="align-middle">{item.dateCreated}</td>

//         <td className="align-middle">
//           {item.status === 'APPROVED' ? (
//             <span className="badge border border-success text-success px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
//               <i className="fa fa-check-circle fs-18px fa-fw me-5px"></i>
//               {t('APPROVED')}
//             </span>
//           ) : item.status === 'IN PROGRESS' ? (
//             <span className="badge border border-primary text-primary px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
//               <i className="fa fa-spinner fs-18px fa-fw me-5px"></i>
//               {t('INPROGRESS')}
//             </span>
//           ) : item.status === 'REJECTED' ? (
//             <span className="badge border border-danger  text-danger  px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
//               <i className="fa fa-times-circle fs-18px fa-fw me-5px "></i>
//               {t('REJECTED')}
//             </span>
//           ) : (
//             ''
//           )}
//         </td>
//         <td className="align-middle text-end">
//           <Link
//             to=""
//             onClick={() => {
//               setTransactionHistoryId(item.transectionHistoryId);
//               setShowModal1(true);
//             }}>
//             <i
//               className="fas fa-lg fa-fw fa-info-circle cursor-pointer"
//               style={{ color: 'var(--theme-color)' }}></i>
//           </Link>
//         </td>
//       </tr>
//     ))}
//   </tbody>
// </table>
// </div>
// <Pagination
// filteredData={filteredSearch}
// dataPerPage={dataPerPage}
// handlePagination={(pageNumber) => setCurrentPage(pageNumber)}
// currentPage={currentPage}
// />
